import { TextField } from "@mui/material";
import { FC } from "react";
import { Control, Controller } from "react-hook-form";

import { CryptorFormData } from "@/pages/cryptor/utils/cryptor.schema";

interface CryptorRewardFieldProps {
  control: Control<CryptorFormData, {}>;
}

const CryptorRewardField: FC<CryptorRewardFieldProps> = ({ control }) => {
  return (
    <Controller
      control={control}
      name="reward"
      render={({ field, fieldState }) => (
        <TextField
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Récompense"
          value={field.value}
          onChange={field.onChange}
          margin="normal"
          error={fieldState.invalid}
          fullWidth
        />
      )}
    />
  );
};

export default CryptorRewardField;
